

const firstHeader =[
    '类别','付款方式','序号','科目名称','期初数','合计', 
]


const border = [
    {
        "rangeType": "range",
        "borderType": "border-all",
        "style": "3",
        "color": "#a4a4a4",
        "range": [{
            "row": [0, 50],
            "column": [0, 23]
        }]
    },
]

export { firstHeader,border }